import { DoqType } from '@ardoq/doq';

export const lockedComponentDialog = () => {
  return {
    title: 'Component is locked',
    subtitle: 'Unlock the component to be able to replace the component image.',
    doqType: DoqType.LOCKED,
  };
};
